module.exports = __webpack_public_path__ + "static/media/Neuzeit Heavy-01.ffde8671.svg";